import { Component, Injector, OnInit } from '@angular/core';
import { BaseComponent } from 'src/app/shared/baseComponent';

@Component({
  selector: 'app-basecomponenttester',
  templateUrl: './basecomponenttester.component.html',
  styleUrls: ['./basecomponenttester.component.css']
})
export class BasecomponenttesterComponent extends BaseComponent implements OnInit {

  constructor(injector: Injector) {super(injector) }
  id= 3;
  names=[
    {id:1,name:"Cesar"},
    {id:2,name:"Betty"},
    {id:3,name:"Amy"},
    {id:4,name:"Peter"},
    {id:5,name:"Elisabeth"},
  ]
  ngOnInit(): void {
  }

}
